import { render, staticRenderFns } from "./TerminalTabBar.vue?vue&type=template&id=fd4d1bda&scoped=true"
import script from "./TerminalTabBar.vue?vue&type=script&lang=ts"
export * from "./TerminalTabBar.vue?vue&type=script&lang=ts"
import style0 from "./TerminalTabBar.vue?vue&type=style&index=0&id=fd4d1bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4d1bda",
  null
  
)

export default component.exports